export const environment = {
	production: true,
	apiUrl: 'https://219l7y1jf5.execute-api.eu-central-1.amazonaws.com/production/api',
	releaseStage: 'production',
	googleAnalyticsTrackingId: 'UA-126821506-1'
};
